import type {
  MiddlewareAPI,
  Middleware,
} from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import { showAlert } from '../alert';
import { showPopup } from '../features/popupSlice';
import { showRefresh } from '../features/refreshSlice';

const responseMiddleware: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    const { dispatch } = api;

    const data = action?.payload?.data;
    const keys = data && Object?.values(data);

    keys?.forEach(
      (element: {
        responseStatus: {
          status: string;
          statusCode: number;
        };
      }) => {
        if (
          element?.responseStatus?.status ===
          'REQUEST_NOT_AUTHORIZED'
        ) {
          if (localStorage.getItem('authToken') == null) {
            dispatch(
              showPopup({
                title: 'Unauthorized User, Session Expired',
                desc: 'Please login to continue.',
              })
            );
          } else {
            dispatch(
              showRefresh({
                title: true,
              })
            );
          }
        } else if (
          element?.responseStatus?.statusCode === 500
        ) {
          dispatch(
            showAlert({
              content: 'Something went wrong.',
              severity: 'error',
            })
          );
        }
      }
    );

    if (isRejectedWithValue(action)) {
      if (
        action.payload?.status === 401 ||
        action.payload?.status === 0
      ) {
        dispatch(
          showPopup({
            title: 'Unauthorized User, Session Expired',
            desc: 'Please login to continue.',
            onSubmit: 'logout',
          })
        );
      } else {
        let message;
        switch (action.payload?.status) {
          case 403: {
            message =
              action.payload?.data?.detail ||
              'Access is denied.';
            break;
          }
          case 400: {
            message = action.payload?.data?.title;
            break;
          }
          case 424: {
            message = action.payload?.data?.detail;
            break;
          }
          default:
            message = 'Something went wrong.';
        }
        dispatch(
          showAlert({
            content: message,
            severity: 'error',
          })
        );
      }
    }

    return next(action);
  };
export default responseMiddleware;
